import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const MonthlyDonationsByBloodGroupChart = ({ data }) => {
  const { t } = useTranslation();

  const bloodGroupColors = {
    "A+": "#e74c3c",
    "A-": "#c0392b",
    "B+": "#3498db",
    "B-": "#2980b9",
    "AB+": "#9b59b6",
    "AB-": "#8e44ad",
    "O+": "#27ae60",
    "O-": "#1e8449",
  };

  const chartData = useMemo(() => {
    if (!data || !Array.isArray(data.months) || data.months.length === 0) return null;

    const datasets = Object.keys(data.bloodGroups).map((bloodGroup) => ({
      label: bloodGroup,
      data: data.bloodGroups[bloodGroup],
      backgroundColor: bloodGroupColors[bloodGroup] || "#666",
      borderColor: bloodGroupColors[bloodGroup] || "#666",
      borderWidth: 1,
    }));

    return {
      labels: data.months,
      datasets,
    };
  }, [data]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: true,
      position: "top",
      labels: {
        fontColor: "#666",
        usePointStyle: true,
        padding: 15,
      },
    },
    tooltips: {
      mode: "index",
      intersect: false,
      callbacks: {
        label: (tooltipItem, chartData) => {
          const datasetLabel = chartData.datasets[tooltipItem.datasetIndex].label;
          return `${datasetLabel}: ${tooltipItem.yLabel} ${t("units")}`;
        },
      },
    },
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
            fontColor: "#666",
          },
          gridLines: {
            color: "rgba(0, 0, 0, 0.1)",
          },
          scaleLabel: {
            display: true,
            labelString: t("Number of Units Collected"),
            fontColor: "#666",
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
          ticks: {
            fontColor: "#666",
          },
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
            labelString: t("Month"),
            fontColor: "#666",
          },
        },
      ],
    },
  };

  if (!chartData) {
    return <p className="text-center mt-3">{t("No data available")}</p>;
  }

  return (
    <div style={{ minHeight: "350px", position: "relative" }}>
      <Bar data={chartData} height={350} options={options} />
    </div>
  );
};

export default MonthlyDonationsByBloodGroupChart;
